export default "__VITE_ASSET__02074d0e__"